import { render, staticRenderFns } from "./BuyCourseModal.vue?vue&type=template&id=87687850&scoped=true"
import script from "./BuyCourseModal.vue?vue&type=script&lang=js"
export * from "./BuyCourseModal.vue?vue&type=script&lang=js"
import style0 from "./BuyCourseModal.vue?vue&type=style&index=0&id=87687850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87687850",
  null
  
)

export default component.exports